/* eslint-disable jsx-a11y/anchor-is-valid */
import UIkit from "uikit";
import React, { useEffect } from "react";

import Layout from "../layout";

import "../../static/scss/policies.scss";

function PrivacyPolicy() {
    useEffect(() => {
        UIkit.accordion(".uk-accordion", { multiple: true });

        const elms = document.querySelectorAll(".uk-hidden");

        elms.forEach(elm => elm.classList.remove("uk-hidden"));
    });

    return (
        <Layout>
            <div className="uk-section">
                <div className="uk-container uk-container-medium policies">
                    <h1 className="uk-margin-top">Privacy Policy for Hopster</h1>

                    <p>Last updated August 2023</p>

                    <h3>Introduction</h3>

                    <p>
                    Welcome to Hopster – the beautifully designed suite of apps (i.e., Hopster, Hopster Coding 
                    Safari, and Hopster Saturday Club for Kids) for the under–sixes.
                    </p>
                    <p>
                    Hopster is the trading name of Plato Media Limited, a UK company with offices at 54 Commercial
                    Street, London, E1 6LT and registered office at 1 Vincent Square, London SW1P 2PN. At Hopster, 
                    \we are committed to protecting you and your family’s personal information. We created Hopster 
                    apps to be a safe and enjoyable environment for everyone. In this Privacy Policy, we’ll explain 
                    the what we do with the information you give us and which we may collect from you as part of 
                    providing the Hopster apps.
                    </p>
                    <p>
                    Hopster apps are designed for 2-6 year old kids and we have drawn together this Privacy Policy 
                    for you, the parent or guardian. Hopster apps comply with the Children’s Online Privacy Protection 
                    Act, (COPPA) a U.S. law that governs the use and collection of information online from kids under 13. 
                    </p>

                    <ul className="uk-accordion  uk-list-divider">
                        <li>
                            <a className="uk-accordion-title" href="#">
                                Important information and who we are
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <h4>Purpose of this Privacy Policy</h4>
                                <p>
                                   This Privacy Policy aims to give you information about the personal information relating 
                                   to you (your personal data) which Hopster collects about you – and what we do with it. 
                                   There may be specific occasions when we collect or use personal data about you and we may 
                                   provide further information on what information we are gathering and why. 
                                   This Privacy Policy is designed to supplement any other notices and won’t override them.
                                </p>
                                <h4>Hopster as Controller</h4>
                                <p>
                                   Hopster is the trading name of Plato Media Limited, a UK company with offices at 54 Commercial Street, 
                                   London, E1 6LT and registered office at 1 Vincent Square, London SW1P 2PN.
                                </p>
                                <p>
                                   A Controller is the person or entity which decides the purposes for which any personal 
                                   data will be used. As Hopster the Hopster app and the data collected and used to allow 
                                   you your family access to the app, Hopster is the data controller and responsible for 
                                   your personal data.
                                </p>
                                <h4>Contact details</h4>
                                <p>Full name of legal entity: Plato Media Limited trading as Hopster</p>
                                <p>
                                    Email address: <a href="mailto:help@hopster.tv">help@hopster.tv</a>
                                </p>
                                <p>
                                   Postal address: 54 Commercial Street, London, E1 6LT 
                                   (our registered office is 1 Vincent Square, London SW1P 2PN)
                                </p>
                                <p>
                                   If you have any questions about this Privacy Policy, or if you would like to exercise 
                                   any of the rights to which you are legally entitled (see information on this, below), 
                                   please contact us using the details set out below.
                                </p>
                                <p>
                                    You have the right to make a complaint at any time to the Information Commissioner’s 
                                    Office (ICO), the UK supervisory authority for data protection issues (www.ico.org.uk). 
                                    We take data protection issues very seriously at Hopster and are confident that the 
                                    processes we have in place will keep your personal data safe. If, however, there are 
                                    any issues, we would really appreciate the chance to resolve anything that’s concerning 
                                    you, before you approach the ICO.
                                </p>
                                <h4>Changes to the Privacy Policy</h4>
                                <p>
                                    The date of the latest version of the Privacy Policy is set out above. Our Privacy 
                                    Policy will be updated from time to time – you can always come back here and check 
                                    for any changes. Alternatively, any material changes to the Privacy Policy will be 
                                    flagged within the Hopster apps.
                                </p>
                                <h4>Third-party links</h4>
                                <p>
                                    Our website may include links to third-party websites. Clicking on those links may 
                                    allow third parties to collect or share data about you. When you leave our website, 
                                    be sure to read the Privacy Policy of any website you go to – we don’t control 
                                    these third-party websites.
                                </p>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                The data we collect about you
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                    Personal data, or personal information, means any information about an individual 
                                    which can identify that individual. It does not include data where the identity has 
                                    been removed (anonymous data).
                                </p>
                                <p>
                                    We may collect, use, store and transfer different kinds of personal data about you, 
                                    which we have grouped together into the following categories:
                                </p>
                                <ul className="uk-list uk-list-circle uk-list-primary uk-list-divider">
                                    <li>
                                        <strong>Contact Data</strong> includes any email address which you might provide 
                                        to us, for example when logging in.
                                    </li>
                                    <li>
                                        <strong>Technical Data</strong> includes your login data, time zone setting and 
                                        location, operating system and platform, device identifiers including device ID 
                                        and advertising ID and other technology on the devices you or your child use to 
                                        access the Hopster applications.
                                    </li>
                                    <li>
                                        <strong>Profile Data</strong> for example, your password.
                                    </li>
                                    <li>
                                        <strong>Usage Data</strong> includes information about how you use the Hopster 
                                        applications. Please note that this may include personal data relating to your 
                                        child’s use of the Hopster apps e.g. records of which puzzles have been successfully 
                                        solved.
                                    </li>
                                </ul>
                                <p>
                                   Please note that any processing of financial data is carried out by the payment provider 
                                   chosen by the user e.g. iTunes, Google Play etc. As such, Hopster apps do not collect, 
                                   store or have access to any financial data.

                                </p>
                                <p>
                                   We also collect, use and – where necessary to provide the Hopster services – we might 
                                   share what we will call Aggregated Data. Aggregated Data may be derived from your 
                                   personal data but is not considered personal data in law as this data does not 
                                   directly or indirectly reveal your identity. For example, we may aggregate your Usage 
                                   Data (using the definition above) to calculate how many subscribers are using a particular 
                                   feature of the Hopster mobile apps. If we combine or connect Aggregated Data with your 
                                   personal data so that it can directly or indirectly identify you, then we treat the 
                                   combined data as personal data – which will always be used in accordance with this 
                                   Privacy Policy.
                                </p>
                                <p>
                                   We do not collect any data which is not necessary to provide the Hopster services to you.
                                </p>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                How is your personal data collected?
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>We use different methods to collect data from and about you including through:</p>
                                <ul className="uk-list uk-list-circle uk-list-primary uk-list-divider">
                                    <li>
                                        <strong>Direct interactions</strong>. You may give us your Contact information by 
                                        filling in forms or by corresponding with us by post, phone, email or otherwise. 
                                        This includes personal data you provide when you:

                                        <ul className="uk-list uk-list-circle uk-list-primary">
                                            <li>enter a competition, promotion or survey; or</li>
                                            <li>give us some feedback.</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Automated technologies</strong> or interactions. As you interact with the 
                                        Hopster apps and our website, we may automatically collect Technical Data about your 
                                        equipment, browsing actions and patterns. We collect this personal data by using cookies, 
                                        automated event logs and other similar technologies. We may also receive Technical 
                                        Data about you if you visit other websites employing our cookies.
                                    </li>
                                    <li>
                                        <strong>Third parties or publicly available sources</strong>. We may receive personal 
                                        data about you from various third parties as set out below:
                                        <ul className="uk-list uk-list-circle uk-list-primary">
                                            <li>Technical Data from the following parties:</li>
                                            <li>
                                                (a) advertising attribution networks such as AppsFlyer based outside the
                                                EU; and
                                            </li>
                                            <li>(b) customer support providers such as ZenDesk based outside the EU</li>
                                            <li>
                                                (c) analytics providers such as Google, and MixPanel based outside the
                                                EU
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Contact, and Transaction Data from providers of technical, payment and delivery
                                        services such as Apple, Google and Stripe based outside the EU.
                                    </li>
                                    <li>
                                        Authentication to Hopster apps via single sign-on providers such as Amazon
                                        login.
                                    </li>
                                    <li>
                                        Authentication to Hopster apps via a commercial partner such as Apple, Amazon,
                                        Google, and Vodafone Iceland.
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                How we use your personal data
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                   We will only use your personal data when the law allows us to. Most commonly, 
                                   we will use your personal data in the circumstances set out below. 
                                   These are called lawful bases for processing:
                                </p>
                                <ul className="uk-list uk-list-circle uk-list-primary">
                                   For performance of a contract with you – wwhere you have requested access to the 
                                   Hopster apps and we use your personal data to set you up as an account holder 
                                   (if you create a Hopster account) and provide the service to you and your family.
                                   Where we need to comply with a legal obligation. Where it is necessary for our 
                                   legitimate interests ((or those of a third party) to manage the Hopster apps to 
                                   ensure the best service/product and the best and most secure experience. 
                                   We will always make sure we balance any legitimate interest against any potential 
                                   impact on you.
                                </ul>

                                <p>
                                   We do not generally rely on your consent as a legal basis for processing your 
                                   personal data. We only use your data where it’s necessary to provide you with the 
                                   Hopster services you have asked to receive – so, we are using your personal data 
                                   to enable us to perform our contractual obligations to you.
                                </p>
                                <strong>Purposes for which we will use your personal data</strong>
                                <p>
                                   We have set out below, in a table format, a description of all the ways we plan 
                                   to use your personal data, and which of the legal bases we rely on to do so. 
                                   We have also explained what our legitimate interests are, where relevant. We might 
                                   process your personal data for more than one lawful basis depending on the 
                                   situation – as explained in the table below. If you would like further detail 
                                   on any of the information set out below, please get in touch.
                                </p>

                                <table className="uk-table uk-table-responsive uk-table-divider">
                                    <thead>
                                        <tr>
                                            <th>Purpose/Activity</th>
                                            <th className="uk-width-1-5">Type of Data</th>
                                            <th>Lawful Basis of Processing</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>To process and deliver your Hopster subscription:</td>
                                            <td>(a) Contract</td>
                                            <td>
                                                (a) Performance of a contract with you
                                                <br />
                                                <br />
                                                (b) Necessary for our legitimate interests (to allow you to access the
                                                Hopster apps)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>To provide the Hopster apps</td>
                                            <td>
                                                (a) Technical
                                                <br />
                                                <br />
                                                (b) Usage
                                                <br />
                                                <br />
                                                (c) Profile
                                            </td>
                                            <td>
                                                (a) Performance of a contract with you
                                                <br />
                                                <br />
                                                (b) Necessary for our legitimate interests (to deliver the best service
                                                to you and improve the Hopster apps and services)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                To manage our relationship with you, which might include asking you to
                                                leave a review or take a survey
                                            </td>
                                            <td>
                                                (a) Contact
                                                <br />
                                                <br />
                                                (b) Profile
                                            </td>
                                            <td>
                                                (a) Performance of a contract between us
                                                <br />
                                                <br />
                                                (b) Necessary to comply with a legal obligation
                                                <br />
                                                <br />
                                                (c) Necessary for our legitimate interests (to keep our records updated
                                                and to study how customers use our products/services)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                To administer and protect the Hopster apps and website (including
                                                troubleshooting, data analysis, testing, system maintenance, support,
                                                reporting and hosting of data)pes
                                            </td>
                                            <td>
                                                (a) Contact
                                                <br />
                                                <br />
                                                (b) Profile
                                                <br />
                                                <br />
                                                (c) Usage
                                                <br />
                                                <br />
                                                (d) Technical
                                            </td>
                                            <td>
                                                (a) Necessary for our legitimate interests (for running our business,
                                                provision of administration and IT services, network security, to
                                                prevent fraud and in the context of a business reorganisation or group
                                                restructuring exercise)
                                                <br />
                                                <br />
                                                (b) Necessary to comply with a legal obligation
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                To use data analytics to improve our website, products/services,
                                                marketing, customer relationships and experienceses
                                            </td>
                                            <td>
                                                (a) Technical
                                                <br />
                                                <br />
                                                (b) Usage
                                                <br />
                                                <br />
                                                (c) Profile
                                            </td>
                                            <td>
                                                (a) Performance of a contract between us
                                                <br />
                                                <br />
                                                (b) Necessary for our legitimate interests (to keep the Hopster apps and
                                                our website updated and relevant, to develop our business and to inform
                                                our business strategy)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                To make suggestions and recommendations to you about goods or services
                                                that may be of interest to you
                                            </td>
                                            <td>
                                                (a) Contact
                                                <br />
                                                <br />
                                                (b) Technical
                                                <br />
                                                <br />
                                                (c) Usage
                                                <br />
                                                <br />
                                                (d) Profile
                                            </td>
                                            <td>
                                                Necessary for our legitimate interests (to develop our products/services
                                                and grow our business)
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <h4>Cookies</h4>
                                <p>
                                   You can set your browser to refuse all or some browser cookies, or to alert you when 
                                   websites set or access cookies. If you disable or refuse cookies, please note that some 
                                   parts of the Hopster apps and website may become inaccessible or not function properly.
                                   Cookies are small text files that we place in visitors’ computer browsers to store their 
                                   preferences. Our cookies themselves do not contain any personal data. Our cookies may 
                                   reference the personal data you provided during registration. 
                                   
                                   We reference the information you provided via an encrypted identifier. Where we link these 
                                   unique identifiers with your personal information, we will treat the unique identifiers 
                                   as personal data as long as they are linked. We use both session ID cookies and persistent 
                                   cookies. We use session cookies to make it easier for you to navigate Hopster apps and services. 
                                   A session ID cookie expires when you close your browser. A persistent cookie remains on your
                                   hard drive for an extended period of time. You can remove persistent cookies by following 
                                   directions provided in your internet browser’s “help” file.
                                   
                                   When your kids use Hopster apps, we collect certain non-personal information by placing 
                                   and accessing Hopster apps cookies on the device they are using. Cookies do not contain 
                                   any personal data, so we do not use cookies (or other covert or non-consensual methods) 
                                   to acquire contact information about your kids or other users of the device.

                                </p>
                                
                            </div>
                        </li>

                        <li>

                        <a className="uk-accordion-title" href="#">
                                Change of purpose
                            </a>   

                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                   We will only use your personal data for the purposes for which we collected it, unless we 
                                   reasonably consider that that we need to use it for another purpose which is compatible with 
                                   the original purpose. If we need to use your personal data for an unrelated purpose, we will 
                                   let you know and we will explain the legal basis which allows us to do so.
                                   Please note that where we have to carry our processing where required by the law, we may 
                                   process your personal data without your knowledge or consent.
                                </p>
                            </div>
                        </li> 

                        <li>
                            <a className="uk-accordion-title" href="#">
                                Disclosures of your personal data
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                    We may have to share your personal data with third parties set out below, for the 
                                    purposes set out in the table in paragraph 4 above.
                                </p>
                                <ul className="uk-list uk-list-circle uk-list-primary uk-list-divider">
                                    <li>
                                        Service providers acting as processors based both inside and outside the EU who 
                                        provide IT and system administration services
                                    </li>
                                    <li>
                                        Cloud infrastructure providers such as Amazon, and Google, based outside the EU
                                    </li>
                                    <li>
                                        Analytics and event tracking providers such as  as Mixpanel and Google Analytics, 
                                        based outside the EU
                                    </li>

                                    <li>Advertising attribution networks such as AppsFlyer based outside the EU</li>

                                    <li>Customer support providers such as ZenDesk based outside the EU</li>
                                    <li>Email providers such as MailChimp based outside the EU</li>
                                    <li>
                                        Professional advisers acting as processors or joint controllers including
                                        lawyers, bankers, auditors and insurers who provide consultancy, banking, legal,
                                        insurance and accounting services.
                                    </li>
                                    <li>
                                        HM Revenue & Customs, regulators and other authorities acting as processors or
                                        joint controllers who require reporting of processing activities in certain
                                        circumstances.
                                    </li>
                                </ul>
                                <p>
                                    We require all third parties to respect the security of your personal data and 
                                    to treat it in accordance with the law. We do not allow our third-party service 
                                    providers to use your personal data for their own purposes and only permit them to 
                                    process your personal data for specified purposes and in accordance with our 
                                    instructions.

                                    We may share personal information collected with the companies within the Sandbox 
                                    International Holdings Ltd. We will not share any personal information about you 
                                    with any third party (a party not affiliated with Sandbox International Holdings Ltd.), 
                                    except as otherwise stated in this Privacy Policy and in the following circumstances: 
                                    (a) in response to subpoenas, court orders or legal process, to the extent 
                                    permitted and as restricted by law; (b) when disclosure is required to maintain the 
                                    security and integrity of this site, or to protect any user's security or the security 
                                    of other persons, consistent with applicable laws; (c) when disclosure is directed or 
                                    consented to by the registered member who has inputted the personal information; 
                                    (d) in the event that Sandbox International Holdings Ltd. (the owner of Hopster) or 
                                    any of its subdivisions or units goes through a business transition, such as a merger, 
                                    divestiture, acquisition, liquidation or sale of all or a portion of its assets, 
                                    your personal information will, in most instances, be part of the assets transferred; 
                                    or (e) in limited circumstances, We may disclose your email address in order to comply 
                                    with laws and regulations, including the Controlling the Assault of Non-Solicited 
                                    Pornography and Marketing Act (CAN-SPAM of 2003).


                                </p>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                International transfers
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                    Some of our external third parties are based outside the European Economic Area (
                                    <strong>EEA</strong>) – which is all EU member countries as well as Iceland,
                                    Liechtenstein and Norway. So, their processing of your personal data will involve a
                                    transfer of data outside the EEA.
                                </p>
                                <p>
                                    Whenever we transfer your personal data out of the EEA, we make sure that similar
                                    levels of protection are in place. Below are some examples of how we do this:
                                </p>
                                <ul className="uk-list uk-list-circle uk-list-primary uk-list-divider">
                                    <li>
                                        Where we use certain service providers, we may use specific contracts which may 
                                        have been approved by the European Commission which give personal data the 
                                        same protection it has in Europe.
                                    </li>
                                    <li>
                                        Where we use providers based in the US, we may transfer data to them if they 
                                        are part of the Privacy Shield which requires them to provide similar protection 
                                        to personal data shared between Europe and the US.
                                    </li>
                                </ul>
                                <p>
                                    Please contact us if you would like further information regarding the transfer of
                                    your personal data out of the EEA.
                                </p>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                Data security
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                   We have put in place security measures to prevent your personal data from being 
                                   accidentally lost, used or accessed in an unauthorised way, altered or disclosed. 
                                   Additionally, we limit access to your personal data to those employees, agents, 
                                   contractors and other third parties who have a business need to know. They will 
                                   only process your personal data on our instructions and they are subject to 
                                   a duty of confidentiality.
                                   We have put in place procedures to deal with any suspected personal data breach 
                                   and will notify you and any applicable regulator of a breach where we are legally 
                                   required to do so.
                                </p>
                                <p>
                                    We have put in place procedures to deal with any suspected personal data breach and
                                    will notify you and any applicable regulator of a breach where we are legally
                                    required to do so.
                                </p>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                Data retention
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <h4>How long will you use my personal data for?</h4>
                                <p>
                                    We will only retain your personal data for as long as necessary to fulfil the 
                                    purposes we collected it for, including for the purposes of satisfying any legal, 
                                    accounting, or reporting requirements.
                                    To determine the appropriate retention period for personal data, we consider the 
                                    amount, nature, and sensitivity of the personal data, the potential risk of harm 
                                    from unauthorised use or disclosure of your personal data, the purposes for which we 
                                    process your personal data and whether we can achieve those purposes through other 
                                    means, and the applicable legal requirements.
                                    In some circumstances you can ask us to delete your data: see Request erasure
                                    below for further information.
                                    We may your personal data (so that it can no longer be associated with you) for research or statistical purposes.
                                </p>
                            </div>
                        </li>

                        <li>
                            <a className="uk-accordion-title" href="#">
                                Your legal rights
                            </a>
                            <div className="uk-accordion-content uk-hidden">
                                <p>
                                    Under certain circumstances, you have rights under data protection laws in relation
                                    to your personal data.
                                </p>
                                <ul className="uk-list uk-list-circle uk-list-primary uk-list-divider">
                                    <li>
                                        <strong>Request access</strong> to your personal data (commonly known as a “data
                                        subject access request”). This enables you to receive a copy of the personal
                                        data we hold about you.
                                    </li>
                                    <li>
                                        <strong>Request correction</strong> of the personal data that we hold about you.
                                        This enables you to have any incomplete or inaccurate data we hold about you
                                        corrected.
                                    </li>
                                    <li>
                                        <strong>Request erasure</strong> of your personal data. This enables you to ask
                                        us to delete or remove personal data.
                                    </li>
                                    <li>
                                        <strong>Object to processing</strong> of your personal data where we are relying 
                                        on a legitimate interest (or those of a third party) and you feel the processing 
                                        impacts on your fundamental rights and freedoms. You also have the right to object 
                                        where we are processing your personal data for direct marketing purposes.

                                    </li>
                                    <li>
                                        <strong>Request restriction</strong> of processing of your personal data. This 
                                        enables you to ask us to suspend the processing of your personal data in the 
                                        following scenarios: (a) if you want us to establish the data’s accuracy; 
                                        (b) where our use of the data is unlawful but you do not want us to erase it; 
                                        (c) where you need us to hold the data even if we no longer require it as you 
                                        need it to establish, exercise or defend legal claims; or 
                                        (d) you have objected to our use of your data but we need to verify whether 
                                        we have overriding legitimate grounds to use it.
                                    </li>
                                    <li>
                                        <strong>Request the transfer</strong> of your personal data to you or to a third
                                        party.
                                    </li>
                                    <li>
                                        <strong>Withdraw consent</strong> at any time where we are relying on consent to
                                        process your personal data.
                                    </li>
                                </ul>
                                <p>If you wish to exercise any of the rights set out above, please contact us.</p>

                                <h4>No fee usually required</h4>
                                <p>
                                    You will not usually have to pay a fee to access your personal data 
                                    (or to exercise any of the other rights). However, we may charge a reasonable 
                                    fee if your request is clearly unfounded, repetitive or excessive. 
                                    Alternatively, we may refuse to comply with your request in these circumstances.
                                </p>

                                <h4>What we may need from you</h4>
                                <p>
                                    We may need to request specific information from you to help us confirm your 
                                    identity and ensure your right to access your personal data (or to exercise any 
                                    of your other rights). This is a security measure to ensure that personal data is 
                                    not disclosed to any person who has no right to receive it. We may also contact you 
                                    to ask you for further information in relation to your request to speed up our 
                                    response.
                                </p>

                                <h4>Time limit to respond</h4>
                                <p>
                                    We try to respond to all legitimate requests within one month. Occasionally it may 
                                    take us longer than a month if your request is particularly complex or you have made 
                                    a number of requests. In this case, we will notify you and keep you updated.
                                </p>
                            </div>
                        </li>
                    </ul>

                    <hr />

                    <h3>Contacting Us</h3>

                    <p>
                        If you wish to contact us about any privacy questions or concerns you may have, please do
                        contact our team via the website.
                    </p>

                    <p>
                        You can also write to us at our parent company, Plato Media Ltd, at our postal address: 54
                        Commercial Street, London, E1 6LT (our registered office is 1 Vincent Square, London SW1P 2PN).
                    </p>
                </div>
            </div>
        </Layout>
    );
}

export default PrivacyPolicy;
